import React from 'react';
import { Grid } from '@mui/material';
import KPICard from './KPICard';
import WorkIcon from '@mui/icons-material/Work';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BarChartIcon from '@mui/icons-material/BarChart';
import { DashboardSummary } from '../../../types/reporting';
import { reportingService } from '../../../services/reportingService';

interface KPIGridProps {
  data?: DashboardSummary;
  loading?: boolean;
}

const KPIGrid: React.FC<KPIGridProps> = ({ data, loading = false }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="Total Jobs Created"
          value={data ? reportingService.formatNumber(data.totalJobsCreated) : '0'}
          change={data?.jobsCreatedChange}
          changeLabel="vs prev period"
          loading={loading}
          icon={<WorkIcon />}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="Conversion Rate"
          value={data ? data.conversionRate.toFixed(1) : '0'}
          valueSuffix="%"
          change={data?.conversionRateChange}
          changeLabel="vs prev period"
          loading={loading}
          icon={<TrendingUpIcon />}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="Total Revenue"
          value={data ? reportingService.formatCurrency(data.totalRevenue) : '$0'}
          change={data?.revenueChange}
          changeLabel="vs prev period"
          loading={loading}
          icon={<AttachMoneyIcon />}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KPICard
          title="Average Job Value"
          value={data ? reportingService.formatCurrency(data.averageJobValue) : '$0'}
          change={data?.averageJobValueChange}
          changeLabel="vs prev period"
          loading={loading}
          icon={<BarChartIcon />}
        />
      </Grid>
    </Grid>
  );
};

export default KPIGrid;
